import React, { Component } from 'react';
import { Col,  Row } from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import AdminStatisticsList from '../components/admin/AdminStatisticsList';
import '../css/style.css';
import '../components/Home.css';



class AdminStatisticsLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="4">
                <Row>
                    <Col >
                     <AdminStatisticsList />
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default AdminStatisticsLayout;